import { useLocation } from 'react-router'
import { useEffect, useRef, useState, useCallback } from 'react'
import { stringToNumber } from 'shared/lib/stringToNumber'
import { uiStore } from 'shared/store/uiStore'

export const useSelectedMessage = (id: number) => {
  const { search, pathname } = useLocation()
  const query = new URLSearchParams(search)
  const messageIdQuery = stringToNumber(query.get('messageId'))
  const [selected, setSelected] = useState(messageIdQuery === id)
  const timeOutSelectedRef = useRef<number | null>(null)

  const onUnSelected = useCallback(() => {
    setSelected(false)

    query.delete('messageId')

    uiStore.changeRoute({
      method: 'replace',
      path: pathname,
      query: query.toString(),
    })
  }, [])

  useEffect(() => {
    if (selected) {
      timeOutSelectedRef.current = window.setTimeout(() => {
        onUnSelected()
      }, 5000)
    }

    return () => {
      if (timeOutSelectedRef.current) {
        clearInterval(timeOutSelectedRef.current)

        timeOutSelectedRef.current = null
      }
    }
  }, [])

  return {
    selected: selected,
    onUnSelected: onUnSelected,
  }
}
